import { Component, ViewChild, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ListingParams } from '../../_models/common/listingParams';
import { CommonService } from '@services/app.common.service';
import { AutoCompleteConfig } from '../../_models/common/AutoCompleteConfig';
import { LookupDataViewComponent } from '../app-LookupDataView/app-LookupDataView.component';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { FormControl } from '@angular/forms';


@Component({
    selector: 'app-autocompletemodal',
    templateUrl: './app-AutoCompleteModal.component.html',
    styleUrls: ['./app-AutoCompleteModal.component.css'],
    standalone: false
})
export class AutoCompleteModalComponent implements OnInit {
  selectedAutoCompleteValue: any;
  listingParams = {} as ListingParams;
  @Input() autoCompleteConfig = {} as AutoCompleteConfig;
  public modalAutoCompleteConfig = {} as AutoCompleteConfig;

  public selectedItems= [] as Array<any>;
  @ViewChild(LookupDataViewComponent, { static: true }) lookupDataViewComponent: LookupDataViewComponent;
  constructor(public bsModalRef: BsModalRef, public common: CommonService) {
    this.lookupDataViewComponent = {} as LookupDataViewComponent;
  }
  ngOnInit() {

    this.modalAutoCompleteConfig = {
      label: this.autoCompleteConfig.label,
      nameAttribute: "",
      dataSourceUrl: this.autoCompleteConfig.dataSourceUrl,
      dataSource: [],
      optionTextField: this.autoCompleteConfig.optionTextField,
      optionValueField: this.autoCompleteConfig.optionValueField,
      placeholder: this.autoCompleteConfig.placeholder,
      required: false,
      showSearchIcon: true,
      allowCustomInput: true,
      formCtrl: {} as FormControl,
      systemPageId: this.autoCompleteConfig.systemPageId,

    };
  }

  onAutoCompleteItemSelected(eventArgs: TypeaheadMatch) {

    if (eventArgs instanceof TypeaheadMatch) {
      if (eventArgs.item) {
        this.lookupDataViewComponent.inputParams.idToSearch = eventArgs.item[this.autoCompleteConfig.optionValueField??""];
        this.lookupDataViewComponent.inputParams.textToSearch = eventArgs.item[this.autoCompleteConfig.optionTextField??""];
        this.lookupDataViewComponent?.getListOfData();
      }
    }
  }
  onAutoCompleteSearchClick(userInput: string) {

    this.lookupDataViewComponent.inputParams.idToSearch = this.selectedAutoCompleteValue;
    this.lookupDataViewComponent.inputParams.textToSearch = userInput;

    this.lookupDataViewComponent?.getListOfData();
  }

  onOkClicked() {

    this.selectedItems = this.lookupDataViewComponent?.GetSelectedItems();
    if (this.selectedItems && this.selectedItems.length) {
      this.bsModalRef.hide();
    } else {
      this.common.Notification.error('Please select a record.');
    }
  }
  typeaheadOnSelect() {

    let x = 4;
  }
}
